const styles = {
  container: {
    backgroundColor: 'white',
  },
};

export default styles;
